// 用户角色枚举
export enum UserRole {
  USER = 'user',                 // 普通用户
  OPERATOR = 'operator',          // 操作员
  ASSESSOR = 'assessor',          // 审核员
  ADMINISTRATOR = 'administrator' // 管理员
}

// 用户角色信息接口
export interface UserRoleInfo {
  role: UserRole;
  isAdmin: boolean;
  isAssessor: boolean;
  isOperator: boolean;
  isUser: boolean;
  permissions: string[];
}

// 用户信息扩展接口
export interface UserInfo {
  username: string;
  nickname?: string;
  avatar?: string;
  role?: UserRole;
  permissions?: string[];
  roles?: Array<{
    role_name: string;
    role_key: string;
    create_by: string;
    create_time: string;
    update_by: string;
    update_time: string;
    remark: any;
    version: any;
  }>;
}
